"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyTpaMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const policy_entity_1 = require("./policy.entity");
const address_entity_1 = require("./address.entity");
const tpa_entity_1 = require("./tpa.entity");
let PolicyTpaMap = class PolicyTpaMap {
};
exports.PolicyTpaMap = PolicyTpaMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], PolicyTpaMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyTpaMap.prototype, "policyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tpa_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyTpaMap.prototype, "tpaId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tpa_branch_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyTpaMap.prototype, "tpaBranchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], PolicyTpaMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], PolicyTpaMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => policy_entity_1.Policy, (policy) => policy.tpaMappings, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "policy_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _c : Object)
], PolicyTpaMap.prototype, "policy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => tpa_entity_1.Tpa, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "tpa_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _d : Object)
], PolicyTpaMap.prototype, "tpa", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => address_entity_1.Address, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "tpa_branch_id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], PolicyTpaMap.prototype, "tpaBranch", void 0);
exports.PolicyTpaMap = PolicyTpaMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("policy_tpa_map")
], PolicyTpaMap);
